const ICONS = [
  'check',
  'close',
  'check-circle',
  'check-square-o',
  'minus-square',
  'minus-square-o',
  'bolt',
  'cogs',
  'male',
  'female',
  'users',
  'wrench',
  'trophy',
  'star',
  'star-half-o',
  'star-o',
  'heart',
  'heart-o',
  'thumbs-up',
  'thumbs-down',
  'thumbs-o-up',
  'thumbs-o-down',
  'hand-stop-o',
  'mars',
  'venus',
  'smile-o',
  'meh-o',
  'frown-o',
] as const;

export const DEFAULT_ICONS = [...ICONS];

export type DefaultIcon = (typeof ICONS)[number];
